<template>
  <schools-editor-wrapper>
    <div>
      <b-row>
        <b-col>
          <h1 class="mb-5">{{ $t('layout.school_management.title') }}</h1>
        </b-col>
      </b-row>
      <br /><br />
      <b-row>
        <b-col>
          <RouterView />
        </b-col>
      </b-row>
    </div>
  </schools-editor-wrapper>
</template>

<script>
export default {
  name: 'SchoolManagement',
  data() {
    return {
      isActive: false,
      activeModule: null,
    }
  },

  methods: {
    setActive: function () {
      this.isActive = !this.isActive
    },
  },
}
</script>

<style scoped>
.nav-pills .nav-link {
  padding: 10px 30px 10px 30px !important;
}
.table td {
  padding: 10px;
  padding-left: 40px;
  padding-right: 40px;
}

.table th {
  padding: 10px;
  padding-left: 40px;
  padding-right: 40px;
}
</style>
